import { TranslationKey } from '@lang';

export type TitlesSelect = {
  label: TranslationKey;
  value: string;
}[];

export const maleTitlesOptions: TitlesSelect = [
  {
    label: 'common.mr',
    value: 'Mr',
  },
];

export const femaleTitlesOptions: TitlesSelect = [
  {
    label: 'common.mrs',
    value: 'Mrs',
  },
  {
    label: 'common.miss',
    value: 'Miss',
  },
  {
    label: 'common.ms',
    value: 'Ms',
  },
];
